import React from "react";
import Settings from "../services/SettingsService"
import NativeInterface from "../services/NativeInterface"
import PropsContainer from "../components/props/PropsContainer"
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const SettingsPage: React.FC = () => {

    React.useEffect(() => {
        document.title=`DimensionX | Settings`;
    }, []);

    function updateSettings(params: any)
    {
        if (params.web_app_host) {
            NativeInterface.setWebAppHost(params.web_app_host);
        }
        return new Promise<any>((resolve, reject) => {
            Settings.saveProps(params);
            resolve({ok: 1});
        });
    }

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <h2 className="text-center mb-3">Settings</h2>
                    <PropsContainer properties={Settings.properties} doSave={updateSettings}/>
                </Col>
            </Row>
        </Container>
    );
};

export default SettingsPage;
